import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const AttendanceSettingsPage = lazy(() => import("@/pages/AttendanceSetting/AttendanceSettingsPage"));
const AttendanceSetting = lazy(() => import("@/pages/AttendanceSetting/AttendanceSetting"));
const Holiday = lazy(() => import("@/pages/AttendanceSetting/Holiday"));
const TimeSheetApprover = lazy(() => import("@/pages/AttendanceSetting/Time-Sheet approver/TimeSheetApprover"));
 
const AttendanceSettingRoute: RouteConfig = {
  path : "",
  pageName: "Attendance Setting",
  element: <AttendanceSettingsPage />,
  permission: ["AttendanceSettings"],
  children : {
    ATTENDANCE_SETTING: {
      path: "attendance-setting",
      element: <AttendanceSetting />,
      pageName: "Attendance Setting",
      sidebar: { show: true, icon: "" }
    },
    HOLIDAY_SETTING: {
      path: "holiday-setting",
      element: <Holiday />,
      pageName: "Holiday Setting",
      sidebar: { show: true, icon: "" }
    },
    TIME_SHEET_APPROVER : {
      path : "timesheetapprover",
      element : <TimeSheetApprover/>,
      pageName : "Timesheet Approver",
      sidebar: { show: true, icon: "" },      
    }
  }
};

export default AttendanceSettingRoute;
